module.exports = __webpack_public_path__ + "static/media/chorthippus_brunneus_002_APA.a8f874f3.mp3";